<template>
  <div>
    <div class="style_h3"><span>Раздел «Другие отчеты»</span></div>
    <div>
      <table class="table_1">
        <tr class="no_line_tr">
          <td class="table_up" tyle="width:70%;">
            <ReportOthers1/>
          </td>
          <td class="td_style_massage_download_help" style="width:30%;">
            <table class="table_message_download_help">
              <caption class="message_download_help">Информация о разделе «Другие отчеты»</caption>
              <td>
                <tr class="message_description_2">Данный раздел не имеет отношение к выгрузке/загрузке публикаций из Scopus и предназначен для возможности самостоятельного формирования иных отчетов из БД НГТУ, имеющих отношение к деятельности библиотеки.</tr>
                <tr class="message_description_2">В настоящее время в данный раздел внесен один отчет «Количество обучающихся студентов в разрезе факультетов, специальностей и предметов».</tr>
              </td>
            </table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style>
  .no_line_tr {
    border: none;
  }
  .table_up {
    vertical-align: top; /* содержимое поднимется к его же верхней границе*/
  }
  .style_h3 {
    background: #e5e3d9;
    padding: 2px 2px;
    text-align: center;
    font-size: 120%;
    font-family: 'Times New Roman', Times, serif;
    font-weight:bold;
  }
  .td_style_massage_download_help {
    vertical-align: top;
    /*border: 1px solid black;*/
  }
  .table_all tr {
    border: none;
  }
  /*table, th, td, tr {*/
  /*  border: 1px solid black;*/
  /*}*/
  hr {
    border: none; /* Убираем границу */
    background-color: #D3D3D3; /* Цвет линии */
    color: #D3D3D3; /* Цвет линии для IE6-7 */
    height: 1px; /* Толщина линии */
  }
  .message_download_help {
    color: darkred;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 120%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание bold */
    border: 1px solid #E7D5C0;
    background-color: #E7D5C0;
  }
  .message_description_2{
    color: black;
    font-family: 'Times New Roman', Times, serif; /* Гарнитура текста */
    font-size: 110%; /* Размер шрифта в процентах */
    font-weight: normal; /* Нормальное начертание */
    text-align:justify;
    /*border: 1px solid black;*/
    /*padding: 5px; /* Поля вокруг текста *!*/
    /*vertical-align: top; /*  содержимое поднимется к его же верхней границе*!*/
  }
  .table_message_download_help {
    border: 2px solid #E7D5C0;
    width:100%;
    padding: 4000px;
    /*vertical-align: top; !*  содержимое поднимется к его же верхней границе*!*!*/
  }
  .table_message_download_help td {
    padding: 4px;
    /*vertical-align: top; !*  содержимое поднимется к его же верхней границе*!*!*/
  }
</style>

<script>
import ReportOthers1 from '@/components/ReportOthers1'

export default {
  name: 'report',
  components: {
    ReportOthers1
  }
}
</script>
